import queryString from 'query-string';
import React from 'react';
import { useFirstMountState } from 'react-use';
// eslint-disable-next-line @typescript-eslint/ban-types
export function useApi(url, initialData, parameters) {
    const isFirstMount = useFirstMountState();
    const [data, setData] = React.useState(initialData);
    const [loading, setLoading] = React.useState(false);
    const params = queryString.stringify(parameters ?? {});
    React.useEffect(() => {
        if (isFirstMount && initialData) {
            return;
        }
        if (!isFirstMount) {
            doAsync();
        }
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        async function doAsync() {
            setLoading(true);
            const res = await fetch(params ? `${url}?${params}` : url);
            const data = await res.json();
            setData(data);
            setLoading(false);
        }
    }, [params, url]);
    return { data, loading };
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function useApiOnLoad(url, initialData, parameters) {
    const [data, setData] = React.useState(initialData);
    const params = queryString.stringify(parameters ?? {});
    React.useEffect(() => {
        doAsync();
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        async function doAsync() {
            const res = await fetch(params ? `${url}?${params}` : url);
            const data = (await res.json());
            setData(data);
        }
    }, [params, url]);
    return data;
}
